// Common Client V2 imports
const { createFeedActions } = require('client-v2/common/containers/feed/actions')

module.exports = createFeedActions(require('./selectors'))
